import React from "react";
import { Link } from "react-router";
import type { IUser } from "../../types/iuser";
import {
  PageContainer,
  PageTopbar,
  PageHeader,
  ContentContainer,
  SectionHeader,
  BreadcrumbItem,
  astryx,
  neutralTheme,
  useDocumentTheme,
} from "@shadowcue/ui";

interface AdminProps {
  currentUser: IUser;
}

const AdminHome = (props: AdminProps) => {
  const mode = useDocumentTheme();

  const breadcrumbs: BreadcrumbItem[] = [{ label: "Admin", href: "/admin" }];

  return (
    <astryx.Theme theme={neutralTheme} mode={mode}>
      <PageContainer>
        <PageTopbar breadcrumbs={breadcrumbs} />

        <ContentContainer loading={false}>
          <PageHeader
            title="Admin Dashboard"
            description={`Welcome, ${props.currentUser.email}.`}
          />

          <astryx.VStack gap={6}>
            <astryx.Card>
              <astryx.VStack gap={4}>
                <SectionHeader title="Quick Links" />
                <astryx.Text>
                  Manage your{" "}
                  <Link to="/admin/script_templates">Script Templates</Link> or{" "}
                  <Link to="/admin/users">Users</Link>.
                </astryx.Text>
              </astryx.VStack>
            </astryx.Card>
          </astryx.VStack>
        </ContentContainer>
      </PageContainer>
    </astryx.Theme>
  );
};

export default AdminHome;
